/**
 * Words and symbols shared by the reports a seller reads after a bulk job.
 */

/**
 * The icon that says how a whole run went, per alert severity — the same icon a report's rows
 * use for the outcome that severity stands for.
 */
export const SEVERITY_ICONS = {
  success: 'solar:check-circle-bold',
  warning: 'solar:danger-triangle-bold',
  error: 'solar:close-circle-bold',
};
